import React, { Component } from 'react';
import './Item.css'
import PermissionTable from '../../permission/PermissionTable'
import {connect} from 'react-redux'
class Item extends Component {

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    let {messages} = this.props
    return(
  		<div>
        <h3>{messages['User Menu Config']}</h3>
        <PermissionTable 
          
        />
  		</div>
  	)
  }

}
 
// export default Item;
export default Item = connect(
  (state) => ({messages: state.message.view.settings.Menu9.Item}),null,null,{withRef:true}
)(Item);



// WEBPACK FOOTER //
// ./src/view/settings/Menu9/Item.js